import { isEqual } from 'lodash';
import React, { Component, useCallback, useState } from 'react';
import styled from 'styled-components';

const Sections = styled.div`
  display: flex;
  flex-grow: 1;
  max-height: calc(100% - 100px);
  min-height: calc(100% - 180px);
`;

const Section = styled.div`
  flex-grow: 1;
  border-right: 1px solid #ececec;
  max-width: 60%;
  height: 100%;
  &.full-width {
    max-width: 100%;
  }
`;

const Header = styled.div`
  padding-bottom: 0;
  max-height: 180px;
  border-bottom: 1px solid #ececec;
`;

const StyleTabPage = styled.div.attrs({
  className: 'full-height flex col'
})``;

function DetailsPageLayout(props) {
  return (
    <StyleTabPage className="white details-page">
      <Header className="details-header">{props.header}</Header>
      <Sections className="details-content">
        {props.sections
          ? props.sections.map((section, idx) => {
              return (
                <Section
                  className={
                    `${section.className} section-${idx}` || `section-${idx}`
                  }
                >
                  {section.component}
                </Section>
              );
            })
          : ''}
      </Sections>
    </StyleTabPage>
  );
}

export const DetailsPageLayoutStyled = {
  Header,
  Section,
  Sections,
  StyleTabPage
};

export default DetailsPageLayout;
